import { ShieldOff } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <section className="h-[100vh] w-[100vw] flex flex-col gap-[10px] items-center justify-center">
      <ShieldOff color="#000000" size={50} />
      <h1 className="text-[20px] font-bold">Unauthorized</h1>
      <p>You do not have access to the requested resource.</p>
      <div>
        <button
          className="h-[40px] bg-[#000000] rounded-[20px] px-[30px] text-white text-[15px]"
          onClick={goBack}
        >
          Go Back
        </button>
      </div>
    </section>
  );
};

export default Unauthorized;
